'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getContentTypeNounKey } from 'page-editor-ui/redux/selectors/i18nKeySelectors';
import { getIsSaveInProgress, getWasLastSaveSuccessful, getIsSavePermanentlyDisabled, getSaveState } from 'ContentEditorUI/redux/selectors/saveDataSelectors';
import { getHasBeenSavedOnceThisSession, getLastSaveDate, getWasLastSaveAnAutoSave } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsSavingEnabled, getHasPermissionsToSave, getUnifiedSaveState } from 'page-editor-ui/redux/selectors/saveSelectors';
import BaymaxSaveButton from 'ContentEditorUI/components/header/BaymaxSaveButton';
import { getHasSaveError } from 'ContentEditorUI/redux/selectors/editingInfoSelectors';
import { getIsReadOnlyButSlugChangeAllowedAfterDowngrades } from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getIsUngatedForPatagonia, getIsUserJitad } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getIsUngatedForUniversalThemeEditor } from 'page-editor-ui/redux/selectors/authSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = state => ({
  allowedSave: getHasPermissionsToSave(state),
  contentTypeNoun: I18n.text(getContentTypeNounKey(state)),
  hasBeenSavedOnceThisSession: getHasBeenSavedOnceThisSession(state),
  hasSaveError: getHasSaveError(state),
  isDisabled: !getIsSavingEnabled(state),
  isSaving: getIsSaveInProgress(state),
  lastSavedDate: getLastSaveDate(state),
  lastSaveSuccessful: getWasLastSaveSuccessful(state),
  permanentlyDisabled: getIsSavePermanentlyDisabled(state),
  wasLastSaveAnAutoSave: getWasLastSaveAnAutoSave(state),
  isReadOnlyButSlugChangeAllowedAfterDowngrades: getIsReadOnlyButSlugChangeAllowedAfterDowngrades(state),
  isUserJitad: getIsUserJitad(state),
  isUngatedForUniversalThemeEditor: getIsUngatedForUniversalThemeEditor(state),
  isUngatedForPatagonia: getIsUngatedForPatagonia(state),
  lastSave: getLastSaveDate(state),
  saveState: getSaveState(state),
  unifiedSaveState: getUnifiedSaveState(state)
});
const PageSaveButtonContainer = ({
  allowedSave,
  contentTypeNoun,
  isDisabled,
  onSaveClick,
  permanentlyDisabled,
  isUngatedForPatagonia,
  isReadOnlyButSlugChangeAllowedAfterDowngrades,
  isUserJitad,
  lastSave,
  saveState,
  unifiedSaveState,
  isUngatedForUniversalThemeEditor,
  getUniversalThemeSupportedLastSave
}) => {
  return /*#__PURE__*/_jsx(BaymaxSaveButton, {
    allowedSave: allowedSave,
    contentTypeNoun: contentTypeNoun,
    isDisabled: isDisabled && !isReadOnlyButSlugChangeAllowedAfterDowngrades,
    onSaveClick: onSaveClick
    // TODO, we think that `permanentlyDisabled` is no longer needed and can be removed
    ,
    permanentlyDisabled: permanentlyDisabled && !isReadOnlyButSlugChangeAllowedAfterDowngrades,
    isUngatedForPatagonia: isUngatedForPatagonia,
    isUserJitad: isUserJitad,
    lastSave: isUngatedForUniversalThemeEditor ? getUniversalThemeSupportedLastSave(lastSave) : lastSave,
    saveState: isUngatedForUniversalThemeEditor ? unifiedSaveState : saveState
  });
};
PageSaveButtonContainer.propTypes = {
  allowedSave: PropTypes.bool.isRequired,
  contentTypeNoun: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onSaveClick: PropTypes.func.isRequired,
  permanentlyDisabled: PropTypes.bool.isRequired,
  isUngatedForPatagonia: PropTypes.bool.isRequired,
  isReadOnlyButSlugChangeAllowedAfterDowngrades: PropTypes.bool.isRequired,
  isUserJitad: PropTypes.bool.isRequired,
  lastSave: PropTypes.instanceOf(Date).isRequired,
  saveState: PropTypes.string.isRequired
};
export default connect(mapStateToProps)(PageSaveButtonContainer);